import { ControllerExecutionSuccessResult, ControllerQueryParameters } from '@carlito/ddd';

import type { ListAvailableTimeslotsController } from '@carlito/hotel-apis';
import { bookitoRequest } from './api';

export type ListAvailableTimeslotsParams =
  ControllerQueryParameters<ListAvailableTimeslotsController>;
export type ListAvailableTimeslotsResponse =
  ControllerExecutionSuccessResult<ListAvailableTimeslotsController>;

export type ValidTimeSlot = ListAvailableTimeslotsResponse['availableTimeSlots'][number];

export async function listAvailableSlots(params: ListAvailableTimeslotsParams) {
  return bookitoRequest<ListAvailableTimeslotsController>('/event/timeslots', {
    method: 'GET',
    queryParameters: params,
  });
}
